import PropertyThumbSliderContainer from "../../../../components/property/detail/PropertyThumbSlider";

const PropertyThumbSlider = () => {
  return <PropertyThumbSliderContainer />;
};

export default PropertyThumbSlider;
